mem.views = { };

mem.render = function (viewName, data) {
  $('main').replaceWith(mem.views[viewName](data));
};

(function buildViews() {
  $('script[type="text/html"]').each(function () {
    mem.views[$(this).attr('id')] = _.template($(this).html(), null, { variable: 'data' });
  });
}());
